<template>
  <div ref="hospedajeRef" class="hospedaje-section">
    <div class="stars-container">
      <div 
        v-for="n in 50" 
        :key="n" 
        class="star" 
        :style="generateStarStyle()"
      ></div>
    </div>

    <h2 class="titulo animate-item">
      <span class="serif">Accommodation</span><br />
      <span class="script">Suggestions</span>
    </h2>

    <div class="imagen-contenedor animate-item">
      <div class="texto-sobre-imagen animate-item">
        Here are some accommodation suggestions for your reservation.
      </div>
      <img src="@/assets/hotel.png" alt="Accommodation" class="imagen-hospedaje" />
    </div>

    <button @click="mostrarOverlay" class="btn-hospedaje animate-item">
      VIEW MORE
    </button>

    <transition name="fade">
      <div v-if="overlayVisible" class="overlay" @click.self="cerrarOverlay">
        <div class="overlay-content">
          <button @click="cerrarOverlay" class="btn-close">×</button>
          <h3 class="overlay-title">Accommodation Options</h3>

          <div class="hospedaje-tarjeta" v-for="(hotel, index) in hoteles" :key="index">
            <p class="hotel-nombre">{{ hotel.nombre }}</p>
            <p class="hotel-direccion">{{ hotel.direccion }}</p>
            <p class="hotel-telefono">{{ hotel.telefono }}</p>
            <a :href="hotel.mapa" target="_blank" class="btn-mapa">
              Book Here
            </a>
          </div>

          <button @click="cerrarOverlay" class="btn-cerrar">
            Close
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'HospedajeSection',
  setup() {
    const hospedajeRef = ref(null)
    const overlayVisible = ref(false)
    const elementosAnimados = ref([])

    const hoteles = [
      {
        nombre: 'Hilton Garden Inn Tampa Northwest/Oldsmar',
        direccion: '4052 Tampa Rd, Oldsmar, FL 34677',
        telefono: '+1 813 891 99 90',
        mapa: 'https://maps.app.goo.gl/SPc1HUDXPGkw7GcY8'
      },
      {
        nombre: 'Courtyard by Marriott Tampa Oldsmar',
        direccion: '4052 Tampa Rd, Oldsmar, FL 34677',
        telefono: '+1 813 891 99 90',
        mapa: 'https://maps.app.goo.gl/SPc1HUDXPGkw7GcY8'
      },
    ]

    const generateStarStyle = () => {
      const top = Math.random() * 100
      const left = Math.random() * 100
      const size = Math.random() * 2 + 1
      const duration = Math.random() * 3 + 2
      const delay = Math.random() * 5
      
      return {
        top: `${top}%`,
        left: `${left}%`,
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      }
    }

    const mostrarOverlay = () => {
      overlayVisible.value = true
      document.body.style.overflow = 'hidden'
    }

    const cerrarOverlay = () => {
      overlayVisible.value = false
      document.body.style.overflow = 'auto'
    }

    onMounted(() => {
      nextTick(() => {
        elementosAnimados.value =
          hospedajeRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index =
                  Array.from(elementosAnimados.value).indexOf(entry.target)

                gsap.fromTo(
                  entry.target,
                  { opacity: 0, y: 40 },
                  {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    delay: index * 0.2,
                    ease: 'power2.out'
                  }
                )

                observer.unobserve(entry.target)
              }
            })
          },
          { threshold: 0.3 }
        )

        elementosAnimados.value.forEach((el) =>
          observer.observe(el)
        )
      })
    })

    return {
      hospedajeRef,
      overlayVisible,
      mostrarOverlay,
      cerrarOverlay,
      hoteles,
      generateStarStyle
    }
  }
}
</script>

<style scoped>
.hospedaje-section {
  position: relative;
  background: linear-gradient(
    to bottom,
    #000000 0%,
    #05041f 35%,
    #08062d 70%,
    #0c0a45 100%
  );
  color: #ffffff;
  font-family: 'Playfair Display', serif;
  text-align: center;
  padding: 60px 20px;
  overflow: hidden;
}





/* Imagen más pequeña */
.imagen-hospedaje {
  width: 200px;
  margin: 0 auto 20px;
  display: block;
  filter: brightness(0) invert(1) opacity(0.9);
}

/* TODO LO DEMÁS IGUAL */
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  opacity: 0.5;
  box-shadow: 0 0 6px white;
  animation: twinkle linear infinite;
}

@keyframes twinkle {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
}

.imagen-contenedor {
  position: relative;
  display: inline-block;
  z-index: 1;
}

.texto-sobre-imagen {
  position: relative;
  top: 10px;
  color: #fff;
  font-size: 18px;
  font-family: 'quote', serif;
  border-radius: 4px;
  margin-bottom: 20px;
  z-index: 10;
  opacity: 0;
}

.btn-hospedaje {
  position: relative;
  z-index: 1;
  background: white;
  color: #000;
  border: 1px solid white;
  padding: 8px 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
}

.btn-hospedaje:hover {
  background: transparent;
  color: white;
}

/* resto igual */
.overlay { position: fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.85); display:flex; justify-content:center; align-items:center; z-index:1000; padding:20px; box-sizing:border-box; overflow-y:auto; }
.overlay-content { background:#fff; color:#1a1a1a; border-radius:12px; padding:20px 15px; max-width:400px; width:100%; text-align:center; font-family:'Poppins', sans-serif; box-sizing:border-box; max-height:90vh; overflow-y:auto; position:relative; }
.btn-close { position:absolute; top:10px; right:15px; font-size:24px; background:none; border:none; cursor:pointer; font-weight:bold; color:#1a1a1a; }
.overlay-title { font-family:'Playfair Display', serif; font-size:18px; margin-bottom:18px; text-transform:uppercase; letter-spacing:1px; }
.hospedaje-tarjeta { margin-bottom:18px; text-align:left; }
.hotel-nombre { font-size:15px; font-weight:bold; }
.hotel-direccion, .hotel-telefono { font-size:12px; color:#444; }
.btn-mapa { display:inline-block; margin-top:6px; font-size:11px; padding:4px 10px; border:1px solid #1a1a1a; color:#1a1a1a; text-transform:uppercase; font-family:'Poppins', sans-serif; text-decoration:none; transition:0.3s ease; }
.btn-mapa:hover { background:#1a1a1a; color:#fff; }
.btn-cerrar { margin-top:20px; background:none; border:1px solid #1a1a1a; padding:6px 14px; font-size:12px; font-family:'Poppins', sans-serif; text-transform:uppercase; cursor:pointer; transition:0.3s ease; }
.btn-cerrar:hover { background:#1a1a1a; color:#fff; }
.animate-item { opacity:0; transform:translateY(40px); }
.fade-enter-active, .fade-leave-active { transition:opacity 0.4s ease; }
.fade-enter-from, .fade-leave-to { opacity:0; }

.titulo {
  margin: 0 0 10px;
  line-height: 1.05;
}

.titulo .serif {
  font-family: 'nombre', cursive;
  font-size: 42px;
  color: #a48250;
  display: inline-block;
}


.titulo .script {
  font-family: 'nombre', cursive;
  font-size: 34px;
  color: #a48250;
  font-weight: 400;
  display: inline-block;
}

</style>
